























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import type { TopArticleVM } from '@jtnews/shared/seedwork/frontend/application';
import { UiStatistic } from '@jtnews/shared/ui';

@Component({
  components: { UiStatistic },
  name: 'TopArticlesItem',
})
export default class TopArticlesItem extends Vue {
  @Prop({
    required: true,
    type: Object,
  })
  item: TopArticleVM;

  @Prop({
    required: true,
    type: Number,
  })
  index: number;

  get linkClass(): 'primary' | 'secondary' {
    return this.index === 1 ? 'primary' : 'secondary';
  }

  @Emit('commentClicked')
  emitClickToComment({ event }: { event: Event }): {
    event: Event;
    articleId: number;
  } {
    return { event, articleId: this.item.id };
  }

  @Emit('articleClicked')
  emitClickToArticle(): { articleId: number } {
    return { articleId: this.item.id };
  }
}
